<template>
  <modal
    name="modal--delete-transfer"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="300"
    :height="'auto'"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4"
    >
      <div class="w-full">
        <div class="text-center text-4xl mb-1 font-extralight tracking-tight">
          Delete Transfer
        </div>
        <div class="text-center text-2xl mb-6 font-extralight tracking-tight">
          Are you sure?
        </div>

        <div class="flex flex-row justify-between mt-3">
          <button
            class="buttonOutline focus:shadow-outline focus:outline-none"
            @click="hideModal"
          >
            Cancel
          </button>
          <button
            class="ml-3 button focus:shadow-outline focus:outline-none bg-red-500 hover:bg-red-600 text-white"
            @click="confirm"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ModalDeleteTransfer',
  data() {
    return {
      transferId: null
    }
  },
  methods: {
    ...mapActions('config', ['setFabVisible']),
    ...mapActions('storeModule/transfers', ['deleteTransfer']),

    beforeOpen(event) {
      if (event.params && event.params.transferId) {
        this.transferId = event.params.transferId
      }
      this.setFabVisible(false)
    },

    beforeClose() {
      this.transferId = null
      this.setFabVisible(true)
    },

    hideModal() {
      this.$modal.hide('modal--delete-transfer')
    },

    confirm() {
      this.deleteTransfer({ id: this.transferId })
        .catch((error) => {
          console.error('Error deleting transfer:', error)
        })
        .finally(() => {
          this.hideModal()
        })
    }
  }
}
</script>
